import { TraitCode } from '@capital-markets-gateway/api-client-identity';
import { useCheckAccountTraits } from '@cmg/auth';

export const useCheckPrivatePlacementTrait = () => {
  return useCheckAccountTraits([TraitCode.XC_PRIVATE_PLACEMENT]);
};
